export default __webpack_public_path__ + "static/media/terminos_quiken.e460e243.pdf";